export enum URLS {
  ACCOUNT = '/overview/account/:tab',
  ORDERS = '/overview/orders/',
  INTEGRATION = '/overview/partners/:company/',
}
